module.exports = __webpack_public_path__ + "img/header.4879c3ca.png";